// @flow
import R from 'ramda';
import * as React from 'react';
import { connect } from 'react-redux';

import { updateUser } from '../../actions/UserActions';

import Modal from '../../../main/components/Modal';
import { getCurrentTimeInUTC } from '../../../main/support/dateUtils';
import { POLICIES_LINK } from '../../support/gdprConstants';
import { type UserReducer as UserState } from '../../types/userTypes';
import Link from '../core/Link';
import Button from '../core/Button';
import Checkbox from '../core/Checkbox';

import { type RouterProps } from '../../router/withRouter';
import { withRouter } from 'react-router-dom';

import Policies from './Policies';

function getDaysRemaining() {
  const currDate = new Date();
  const may25 = new Date('2018-05-25');
  return Math.round((may25 - currDate) / (1000 * 60 * 60 * 24));
}

type ExternalProps = {
  location: { pathname: string },
  user: UserState
};

type Props = ExternalProps & {
  updateUser: (app: any) => any
} & RouterProps;

type State = { checked: boolean };

class ModalGdpr extends React.Component<Props, State> {
  state = { checked: false };

  closeModal = () => {
    this.props.history.push(this.props.location.pathname);
  };
  onConsent = () =>
    this.props
      .updateUser({ terms_consent_date: getCurrentTimeInUTC() })
      .then(this.closeModal);

  _handleChange = (e: any) => {
    this.setState({ checked: e.target.checked });
  };

  render() {
    const daysRemaining = getDaysRemaining();

    return (
      <Modal open="true" forceAction={true} size="md">
        <div className="standard-modal" data-testid="gdpr-modal">
          <div className="standard-modal__title">
            Updated Terms & Conditions and Privacy Policy
          </div>
          <div className="standard-modal__body">
            <div className="gdpr-modal__tos-content">
              <Policies />
            </div>
          </div>
          <div className="h_p-20">
            <div>
              <Checkbox
                id="terms"
                checked={this.state.checked}
                onChange={this._handleChange}
                label={
                  <div className="h_d-ib">
                    I accept Branch's Terms & Conditions and Privacy Policy.{' '}
                    <Link testid="gdpr-modal_learn-more" href={POLICIES_LINK}>
                      Learn More
                    </Link>
                  </div>
                }
              />
            </div>
            <div className="gdpr-modal_btn-group" style={{ height: '50px' }}>
              <Button
                className="h_fl-end h_mx-10"
                onClick={this.onConsent}
                testid="gdpr-modal_agree"
                disabled={!this.state.checked || this.props.user.loading}
              >
                Continue
              </Button>
              {daysRemaining > 0 ? (
                <Button
                  type="secondary"
                  className="h_fl-end"
                  testid="gdpr-modal_skip"
                  onClick={this.closeModal}
                >
                  Skip
                </Button>
              ) : null}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchProps = dispatch => ({
  updateUser: user => dispatch(updateUser(user))
});

const ConnectedModalGdpr: React.ComponentType<ExternalProps> = connect(
  R.pick(['user']),
  mapDispatchProps
)(withRouter(ModalGdpr));

export default ConnectedModalGdpr;
